<div class="card">

     <!-- TOOLBAR -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">

            <!-- BACK BUTTON -->
            <button pButton pRipple label="regresar" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBack()"></button>
        </ng-template>
    </p-toolbar>


    <!-- Table -->
    <p-table #dt [value]="versionHistoryList" [rows]="50" [paginator]="false"
        [globalFilterFields]="['versionDate','versionNum','summary','secre','treas','mater','school','internat','zone','national','local']"
        [(selection)]="selectedVersionHistoryList" [rowHover]="true" dataKey="id" [showCurrentPageReport]="true"
        responsive="true">

        <ng-template pTemplate="caption">
            <div class="p-d-flex p-flex-column">
                <h5 class="p-m-0">Registro de Versiones</h5>
                <div class="p-d-flex
                p-ai-center p-jc-between">
                    <span style="display: inline-flex;">


                        <button pButton pRipple icon="pi pi-plus" class="p-mr-4 z-5"
                            *ngIf="onlyShow && onlyShow=='true'" (click)="openNew()"></button>


                        <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                            *ngIf="onlyShow && onlyShow=='true'" class="p-button-success p-mr-2 z-5" pTooltip="XLS"
                            tooltipPosition="bottom"></button>

                        <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                            *ngIf="onlyShow && onlyShow=='true'" class="p-button-warning p-mr-2" pTooltip="PDF"
                            tooltipPosition="bottom"></button>


                    </span>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                            *ngIf="onlyShow && onlyShow=='true'" placeholder="Buscar" />
                    </span>

                </div>
            </div>


        </ng-template>

        <ng-template pTemplate="header">
            <tr>

                <th [ngStyle]="{'width': (onlyShow && onlyShow === 'true') ? '' : '20%'}" pSortableColumn="versionDate">
                    Fecha <p-sortIcon field="versionDate"></p-sortIcon></th>
                <th [ngStyle]="{'width': (onlyShow && onlyShow === 'true') ? '' : '20%'}" pSortableColumn="versionNum">
                    Versión Número <p-sortIcon field="versionNum"></p-sortIcon></th>
                <th [ngStyle]="{'width': (onlyShow && onlyShow === 'true') ? '' : '60%'}" pSortableColumn="summary">
                    Descripción <p-sortIcon field="summary"></p-sortIcon></th>


                    <th *ngIf="onlyShow && onlyShow=='true'" pSortableColumn="coord">Coordinador <p-sortIcon
                        field="coord"></p-sortIcon>
                <th *ngIf="onlyShow && onlyShow=='true'" pSortableColumn="secre">Secretario <p-sortIcon
                        field="secre"></p-sortIcon>
                <th *ngIf="onlyShow && onlyShow=='true'" pSortableColumn="treas">Tesorero <p-sortIcon
                        field="treas"></p-sortIcon>
                <th *ngIf="onlyShow && onlyShow=='true'" pSortableColumn="mater">Materiales<p-sortIcon
                        field="mater"></p-sortIcon>
                        <th *ngIf="onlyShow && onlyShow=='true'" pSortableColumn="youngs">Jovenes<p-sortIcon
                            field="youngs"></p-sortIcon>
                <th *ngIf="onlyShow && onlyShow=='true'" pSortableColumn="school">Encargado de EPGs <p-sortIcon
                        field="school"></p-sortIcon>
                <th *ngIf="onlyShow && onlyShow=='true'" pSortableColumn="internat">Internacional <p-sortIcon
                        field="internat"></p-sortIcon>
                <th *ngIf="onlyShow && onlyShow=='true'" pSortableColumn="zone">Zonal <p-sortIcon
                        field="zone"></p-sortIcon>
                <th *ngIf="onlyShow && onlyShow=='true'" pSortableColumn="national">Nacional <p-sortIcon
                        field="national"></p-sortIcon>
                <th *ngIf="onlyShow && onlyShow=='true'" pSortableColumn="local">Local <p-sortIcon
                        field="local"></p-sortIcon>

                </th>
                <th *ngIf="onlyShow && onlyShow=='true'"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-versionHistory>
            <tr>

                <td>{{ formatDate(versionHistory.versionDate) }}</td>
                <td>{{ versionHistory.versionNum }}</td>
                <td *ngIf="languageToShow=='es'">{{ versionHistory.summary }}</td>
                <td *ngIf="languageToShow=='en'">{{ versionHistory.summaryen }}</td>
                <td *ngIf="languageToShow=='pt'">{{ versionHistory.summarypt }}</td>

                <ng-container *ngIf="onlyShow && onlyShow=='true'">
                    <td
                        *ngFor="let column of ['coord','secre', 'treas', 'mater','youngs', 'school', 'internat', 'zone', 'national', 'local']">
                        <span class="pi"
                            [ngClass]="versionHistory[column] === '1' ? 'pi-check-circle' : 'pi-times-circle'"
                            [style.color]="versionHistory[column] === '1' ? 'green' : 'red'"></span>
                    </td>
                </ng-container>



                <td *ngIf="onlyShow && onlyShow=='true'">
                    <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                        (click)="editVersionHistory(versionHistory)"></button>
                    <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning"
                        (click)="deleteVersionHistory(versionHistory)"></button>
                </td>
            </tr>

        </ng-template>

    </p-table>
</div>


<!-- Alert & Confirm -->
<p-toast></p-toast>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- Dialog Details / Edit -->
<p-dialog [(visible)]="versionHistoryDialog" [style]="{width: '450px'}" header="Crear / Actualizar Versión"
    [modal]="true" styleClass="p-fluid">
    <ng-template pTemplate="content">

        <div class="p-field">
            <label for="versionDate">Fecha </label>
            <p-calendar required inputId="basic" [(ngModel)]="versionHistory.versionDateFormated" [readonlyInput]="true"
                dateFormat="yy-mm-dd"></p-calendar>
            <small class="p-error" *ngIf="submitted && !versionHistory.versionDateFormated">Versión
                es requerida</small>
        </div>

        <div class="p-field">
            <label for="versionNum">Versión Número</label>
            <input type="text" pInputText id="versionNum" [(ngModel)]="versionHistory.versionNum" required autofocus />
            <small class="p-error" *ngIf="submitted && !versionHistory.versionNum">Número de Versión es
                requerido</small>
        </div>



        <div class="p-field">
            <label for="role">Rol</label>
            <p-multiSelect [options]="roleList" [(ngModel)]="versionHistory.rolesList" defaultLabel="Rol"
                optionLabel="label" selectedItemsLabel="{0} items selected" inputId="role"></p-multiSelect>
            <small class="p-error" *ngIf="submitted && !versionHistory.rolesList">Role es requerido</small>
        </div>

        <div class="p-field">
            <label for="level">Nivel</label>
            <p-multiSelect [options]="levelList" [(ngModel)]="versionHistory.levelsList" defaultLabel="Nivel"
                optionLabel="label" selectedItemsLabel="{0} items selected" inputId="level"></p-multiSelect>
            <small class="p-error" *ngIf="submitted && !versionHistory.levelsList">Nivel es requerida</small>
        </div>
        <div class="p-field">
            <label for="summary">Descripción Español</label>
            <small class="p-error" *ngIf="submitted && !versionHistory.summary">Descripción es requerida</small>
            <textarea id="summary" [(ngModel)]="versionHistory.summary" rows="5" cols="30" pInputTextarea required
                autofocus autoResize="autoResize" maxlength="300" #myInput></textarea>
            <label class="nopadding clrlbl">{{myInput.value.length}} / 300 </label>
        </div>
        <div class="p-field">
            <label for="summary">Descripción Inglés</label>
            <small class="p-error" *ngIf="submitted && !versionHistory.summaryen">Descripcion es requerida</small>
            <textarea id="summary" [(ngModel)]="versionHistory.summaryen" rows="5" cols="30" pInputTextarea required
                autofocus autoResize="autoResize" maxlength="300" #myInputen></textarea>
            <label class="nopadding clrlbl">{{myInputen.value.length}} / 300 </label>
        </div>
        <div class="p-field">
            <label for="summary">Descripción Portugués</label>
            <small class="p-error" *ngIf="submitted && !versionHistory.summarypt">Descripción es requerida</small>
            <textarea id="summary" [(ngModel)]="versionHistory.summarypt" rows="5" cols="30" pInputTextarea required
                autofocus autoResize="autoResize" maxlength="300" #myInputpt></textarea>
            <label class="nopadding clrlbl">{{myInputpt.value.length}} / 300 </label>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
            (click)="hideDialog()"></button>
        <button pButton pRipple label="Guardar" icon="pi pi-check" class="p-button-text"
            (click)="isFormValid()"></button>
    </ng-template>
</p-dialog>